/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import NotificationViewallCard from "../../../components/Notification/NotificationViewallCard";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";

import Loader from "../../../components/Loader/Index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";

import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import {
  enableSwitcher,
  disableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import useCustomSearchParams from "../../../utils/useCustomSearchParams.js";
import {
  favouriteNotification,
  markNotificationRead,
  notificationsViewAll,
  setBulkEditState,
  setNotificationFilters,
  snoozeNotification,
  unsnoozeNotification,
  updateNotificationArrayInStore,
  setNotiID,
  updateNotificationInStore,
  setCardAnimate,
  notificationsBulkEdit,
  resetNotificationsData,
} from "../../../redux/features/Notifications/index.js";
import ICONS from "../../../assets/Icons/index.js";
import SnoozePopup from "../../../components/_utils/SnoozePopup/index.jsx";
import nameConversion from "../../../utils/nameConversion.js";
import useMultiSelect from "../../../utils/useMultiSelect.js";
import UseHandleScroll from "../../../hooks/useHandleScroll";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import { toast } from "react-toastify";
import SmallPopup from "../../../components/_utils/CommonSmallPopup/index.jsx";
import ChannelViewAll from "../../Channels/ChannelViewall/index.jsx";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import TEXT from "../../../utils/globalText.js";

const NotificationViewall = ({
  typepop,
  flow,
  channelId,
  channelLinkageStatus,
  channelActiveStatus,
}) => {
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");
  const visibilityTimersRef = useRef(new Map());
  const markedVisibleNotificationIdsRef = useRef(new Set());
  const pendingReadNotificationIdsRef = useRef(
    new Set(
      JSON.parse(
        sessionStorage.getItem("pending_notification_read_ids") || "[]",
      ),
    ),
  );
  const locallyReadNotificationIdsRef = useRef(new Set());
  const hasFlushedReadNotificationsRef = useRef(false);

  const pendingUndoToastRef = useRef(null);

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.notificationCardHeight,
  );

  const navigate = useNavigate();

  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    return date;
  };
  const [cardSnoozeNotification, setCardSnoozeNotification] = useState(null);
  const [moreActionPopup, setMoreActionPopup] = useState(false);
  const [moreActionPopupID, setMoreActionPopupID] = useState("");
  const getNotificationId = (notification) =>
    notification?.id || notification?.notification_id;

  const clearCardAnimation = () => {
    dispatch(setCardAnimate(false));
  };

  const markNotificationAsRemoved = (notificationId) => {
    setOptimisticallyRemovedNotificationIds((prev) =>
      prev.includes(notificationId) ? prev : [...prev, notificationId],
    );
  };

  const updateSelectedNotification = (notificationId, payload) => {
    setselectedNotifications((prev) =>
      prev.map((item) => (item.id === notificationId ? payload : item)),
    );
  };

  const removeSelectedNotification = (notificationId) => {
    setselectedNotifications((prev) =>
      prev.filter((item) => item?.id !== notificationId),
    );
  };

  const { handleChange, handleSelectAll, handleSingleSelect } =
    useMultiSelect();

  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams();

  const dispatch = useDispatch();

  const {
    notificationsData,
    notificationsLoading,
    notificationsError,
    notificationsCacheData,
    notiID,
    cardAnimate,
    notificationsBulkEditLoading,
  } = useSelector((state) => state?.notificationsSlice);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const filterRef = useRef(null);
  //useState section
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [sortType, setSortType] = useState(searchParam.get("sort") || "");
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [bulkMsg, setBulkMsg] = useState("");
  const [isSnoozeView, setIsSnoozeView] = useState(
    location.state?.isSnoozeView === true,
  );
  const [testView, setTestView] = useState(false);
  const [localReadVersion, setLocalReadVersion] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [showMarkAllPopup, setShowMarkAllPopup] = useState(false);
  const [isChannelViewAllOpen, setIsChannelViewAllOpen] = useState(false);

  const [snoozeLoading, setSnoozeLoading] = useState(false);
  const [selectedNotifications, setselectedNotifications] = useState([]);
  const [searchUserTextDebounce, setsearchUserTextDebounce] = useState("");
  const [showSnoozePopup, setShowSnoozePopup] = useState(false);
  const [bulkEdit, setBulkEdit] = useState(false);
  const [
    optimisticallyRemovedNotificationIds,
    setOptimisticallyRemovedNotificationIds,
  ] = useState([]);

  const [notificationEntryAnimationIds, setNotificationEntryAnimationIds] =
    useState([]);
  const [notificationType, setNotificationType] = useState(
    location?.state?.read
      ? location?.state?.read
      : searchParam.get("type") || "unread",
  );
  const [favType, setFavType] = useState(
    location?.state?.fav ? location?.state?.fav : searchParam.get("fav") || "",
  );

  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [targetName, setTargetName] = useState(searchParam.get("target") || "");

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const { services } = useSelector((state) => state.refreshToken);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [active, setActive] = useState("");

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const isAllowed = services?.includes("Notify") || services?.includes("Admin");

  const flushPendingReadNotifications = useCallback(async () => {
    if (hasFlushedReadNotificationsRef.current) return;

    const notificationIds = Array.from(pendingReadNotificationIdsRef.current);

    if (!notificationIds.length || !isAllowed) return;

    hasFlushedReadNotificationsRef.current = true;

    try {
      const response = await dispatch(
        notificationsBulkEdit({
          read: true,
          notification_ids: notificationIds,
        }),
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        pendingReadNotificationIdsRef.current.clear();
        sessionStorage.removeItem("pending_notification_read_ids");
      } else {
        hasFlushedReadNotificationsRef.current = false;
      }
    } catch (error) {
      hasFlushedReadNotificationsRef.current = false;
      console.error("Failed to bulk mark notifications as read", error);
    }
  }, [dispatch, isAllowed]);

  const flushPendingReadNotificationsRef = useRef(
    flushPendingReadNotifications,
  );

  useEffect(() => {
    flushPendingReadNotificationsRef.current = flushPendingReadNotifications;
  }, [flushPendingReadNotifications]);

  const queueNotificationForRead = useCallback(
    (notification) => {
      const notificationId = getNotificationId(notification);

      if (!notificationId || !isAllowed) return;

      const notificationIdKey = String(notificationId);
      pendingReadNotificationIdsRef.current.add(notificationIdKey);
      locallyReadNotificationIdsRef.current.add(notificationIdKey);
      hasFlushedReadNotificationsRef.current = false;

      sessionStorage.setItem(
        "pending_notification_read_ids",
        JSON.stringify(Array.from(pendingReadNotificationIdsRef.current)),
      );

      setLocalReadVersion(
        (version) => version + GlobalConfiguration.lengthCheckOne,
      );
    },
    [isAllowed],
  );

  const onMount = async () => {
    const pendingUndo = JSON.parse(
      sessionStorage.getItem("pendingNotificationUndo") || "null",
    );

    if (pendingUndo) {
      const { action, notificationId, snoozed_until } = pendingUndo;

      if (action === "favourite" || action === "unfavourite") {
        await dispatch(
          favouriteNotification({
            id: notificationId,
            favourite: action === "favourite",
          }),
        );
      } else if (action === "snooze") {
        await dispatch(
          snoozeNotification({ id: notificationId, snoozed_until }),
        );
      } else if (action === "unsnooze") {
        await dispatch(unsnoozeNotification({ id: notificationId }));
      }

      sessionStorage.removeItem("pendingNotificationUndo");
    }

    fetchData();
  };

  //Write Function section

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if (
      bulkEdit &&
      value === PaginationConfiguration.paginationSmall &&
      selectedNotifications?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(
        selectedNotifications,
        setselectedNotifications,
        value,
        selectedNotifications,
      );
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleFilterDateRange = (date) => {
    if (!date || !date[0] || !date[1]) {
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }
    const [start, end] = date;
    setStartDateFilter(start);
    setEndDateFilter(end);
  };

  const fetchFilterData = async () => {
    switch (active) {
      case "Search":
        setSearchUserText(searchUserTextDebounce);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  const handlePagination = (page) => {
    setselectedNotifications([]);
    if (filterRef.current) {
      filterRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  //useEffect section
  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      void commitPendingUndo();
      void flushPendingReadNotificationsRef.current();
      dispatch(setNotiID(""));
      dispatch(disableSwitcher());
    };
  }, []);

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const converDate = (date) => {
    return (
      String(date.getDate()).padStart(2, "0") +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      date.getFullYear()
    );
  };

  async function fetchData() {
    try {
      await flushPendingReadNotifications();
      const filters = {
        provider: targetName ? nameConversion(targetName) : undefined,
        channel_id: channelId ? channelId : undefined,
        search_string: searchUserText || undefined,
        read:
          notificationType && !isSnoozeView && notificationType !== "all"
            ? false
            : undefined,
        favourite: favType ? favType === "Show only favourite" : undefined,
        start_date:
          startDateFilter && endDateFilter
            ? converDate(startDateFilter)
            : undefined,
        end_date:
          endDateFilter && startDateFilter
            ? converDate(endDateFilter)
            : undefined,
        sort_by: sortType
          ? sortType === "Date : Old to new"
            ? "desc"
            : sortType === "Alphabetical : A to Z"
              ? "message_asc"
              : sortType === "Alphabetical : Z to A"
                ? "message_desc"
                : undefined
          : undefined,
        active: isSnoozeView ? undefined : true,
        snoozed: isSnoozeView || undefined,
      };
      dispatch(setNotificationFilters(filters));
      const response = await dispatch(
        notificationsViewAll({
          page_no: currentPage,
          page_size: pageSize,
          ...filters,
        }),
      );
    } catch (error) {
      console.error(error);
    }
  }

  const commitPendingUndo = async () => {
    const pending = pendingUndoToastRef.current;

    if (!pending) return;

    pending.shouldCallApi = false;

    if (pending.toastId) {
      toast.dismiss(pending.toastId);
    }

    pendingUndoToastRef.current = null;
    sessionStorage.removeItem("pendingNotificationUndo");

    if (pending.action === "favourite" || pending.action === "unfavourite") {
      await dispatch(
        favouriteNotification({
          id: pending.notificationId,
          favourite: pending.action === "favourite",
        }),
      );
    }

    if (pending.action === "unsnooze") {
      await dispatch(
        unsnoozeNotification({
          id: pending.notificationId,
        }),
      );
    }

    if (pending.action === "snooze") {
      await dispatch(
        snoozeNotification({
          id: pending.notificationId,
          snoozed_until: pending.snoozed_until,
        }),
      );
    }
  };

  useEffect(() => {
    onMount();
  }, [
    currentPage,
    searchUserText,
    pageSize,
    markerData,
    targetName,
    favType,
    notificationType,
    startDateFilter,
    pageSize,
    endDateFilter,
    sortType,
    isSnoozeView,
  ]);

  useEffect(() => {
    if (
      notificationsData?.title?.total_pages === Number(currentPage) &&
      notificationsCacheData?.notifications?.length === 0
    ) {
      setCurrentPage(
        Math.max(
          currentPage - GlobalConfiguration.lengthCheckOne,
          GlobalConfiguration.lengthCheckOne,
        ),
      );
    }
  }, [notificationsCacheData, notificationsData]);

  const clearFilter = () => {
    setTargetName("");
    setSearchUserText("");
    setsearchUserTextDebounce("");
    setFavType("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup") {
      handleSearchParams(key, value);
    }
  };

  const handleSelectall = () => {
    handleSelectAll(
      selectedNotifications,
      setselectedNotifications,
      selectedValue,
      notificationsData?.notifications,
    );
  };

  const handleMarkNotification = async (id, data, isBulk, isAutoRead) => {
    dispatch(setNotiID(id));
    const response = await dispatch(
      markNotificationRead({
        id: id,
        read: !data,
      }),
    );
    if (response?.payload?.status) {
      setTestView(isAutoRead ? false : true);
      await dispatch(
        setCardAnimate(isAutoRead ? false : notificationType?.length),
      );
      dispatch(
        updateNotificationInStore({
          response: response?.payload,
          stateToUpdate: `notificationsData`,
        }),
      );
      updateSelectedNotification(id, response?.payload);

      if (!isBulk && !isAutoRead && notificationType?.length) {
        setTimeout(() => {
          dispatch(
            updateNotificationArrayInStore({
              response: response?.payload,
              stateToUpdate: `notificationsData`,
              notificationType: notificationType.toLowerCase(),
              notificationLength: selectedNotifications?.length,
            }),
          );
        }, 600);
      }
      if (
        selectedNotifications.find((itm) => itm.id === id) &&
        notificationType
      ) {
        setselectedNotifications((prev) =>
          prev.filter((itm) => itm?.id !== id),
        );
      }
    }
    setTimeout(() => {
      setTestView(false);
      clearCardAnimation();
    }, 600);
    return response;
  };

  const handleMarkFavorite = async (id, data, isBulk) => {
    const shouldShowUndo =
      !isBulk &&
      !isSnoozeView &&
      ((favType === "Show only favourite" && data === true) ||
        (favType === "Hide favourite" && data === false));

    const undoAction =
      favType === "Show only favourite" ? "unfavourite" : "favourite";

    if (shouldShowUndo) {
      await commitPendingUndo();

      const currentNotification = notificationsData?.notifications?.find(
        (notification) => notification?.id === id,
      );

      pendingUndoToastRef.current = {
        notificationId: id,
        notification: currentNotification,
        action: undoAction,
        toastId: null,
        shouldCallApi: true,
      };

      sessionStorage.setItem(
        "pendingNotificationUndo",
        JSON.stringify({
          notificationId: id,
          action: undoAction,
        }),
      );

      dispatch(setNotiID(id));
      await dispatch(setCardAnimate(true));

      const newFavouriteValue =
        favType === "Show only favourite" ? false : true;

      dispatch(
        updateNotificationInStore({
          response: {
            ...currentNotification,
            id,
            favourite: newFavouriteValue,
          },
          stateToUpdate: "notificationsData",
        }),
      );

      setTimeout(() => {
        const pending = pendingUndoToastRef.current;

        if (
          !pending ||
          pending.notificationId !== id ||
          pending.action !== undoAction ||
          !pending.shouldCallApi
        ) {
          clearCardAnimation();
          return;
        }

        markNotificationAsRemoved(id);

        clearCardAnimation();
      }, 600);

      const toastId = CommonToast({
        text:
          undoAction === "unfavourite"
            ? TEXT?.NOTIFICATION_UNFAVOURITED_SUCCESSFULLY
            : TEXT?.NOTIFICATION_FAVOURITED_SUCCESSFULLY,
        variant: "var(--primary-nav)",
        buttonNeeded: true,
        btnType: "btnWithoutIcon",
        btnProps: {
          btnText: TEXT?.UNDO,
          handleFunction: () => {
            handleUndoNotification(id);
          },
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-card)",
        },
        toastOptions: {
          onClose: () => {
            const pending = pendingUndoToastRef.current;

            if (!pending?.shouldCallApi) return;

            if (
              pending.notificationId !== id ||
              pending.action !== undoAction
            ) {
              return;
            }

            pending.shouldCallApi = false;
            pendingUndoToastRef.current = null;

            sessionStorage.removeItem("pendingNotificationUndo");

            dispatch(
              favouriteNotification({
                id,
                favourite: undoAction === "favourite",
              }),
            );
          },
        },
      });

      pendingUndoToastRef.current.toastId = toastId;

      return;
    }
    dispatch(setNotiID(id));
    const response = await dispatch(
      favouriteNotification({
        id,
        favourite: !data,
      }),
    );
    if (response?.payload?.status) {
      setTestView(true);

      await dispatch(setCardAnimate(favType?.length));
      if (!bulkEdit) {
        dispatch(
          updateNotificationInStore({
            response: response?.payload,
            stateToUpdate: "notificationsData",
          }),
        );
      }

      updateSelectedNotification(id, response?.payload);
    }

    if (!isBulk && favType?.length) {
      setTimeout(() => {
        dispatch(
          updateNotificationArrayInStore({
            response: response?.payload,
            stateToUpdate: "notificationsData",
          }),
        );
      }, 600);
    }
    if (selectedNotifications.find((itm) => itm.id === id) && favType?.length) {
      removeSelectedNotification(id);
    }
    setTimeout(() => {
      setTestView(false);

      dispatch(setCardAnimate(false));
    }, 600);
    return response;
  };

  const handleUnsnoozeNotification = async (id) => {
    if (isSnoozeView) {
      await commitPendingUndo();

      const currentNotification = notificationsData?.notifications?.find(
        (notification) => notification?.id === id,
      );
      pendingUndoToastRef.current = {
        notificationId: id,
        notification: currentNotification,
        action: "unsnooze",
        toastId: null,
        shouldCallApi: true,
      };

      sessionStorage.setItem(
        "pendingNotificationUndo",
        JSON.stringify({
          notificationId: id,
          action: "unsnooze",
        }),
      );

      dispatch(setNotiID(id));
      await dispatch(setCardAnimate(true));

      dispatch(
        updateNotificationInStore({
          response: {
            ...currentNotification,
            id,
            snoozed_until: 0,
          },
          stateToUpdate: "notificationsData",
        }),
      );
      setTimeout(() => {
        markNotificationAsRemoved(id);

        clearCardAnimation();
      }, 600);
      const toastId = CommonToast({
        text: `Notification unsnoozed successfully.`,
        variant: "var(--primary-nav)",
        buttonNeeded: true,
        btnType: "btnWithoutIcon",
        btnProps: {
          btnText: TEXT?.UNDO,
          handleFunction: () => {
            handleUndoNotification(id);
          },
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-card)",
        },
        toastOptions: {
          onClose: () => {
            const pending = pendingUndoToastRef.current;

            if (!pending?.shouldCallApi) return;

            if (
              pending.notificationId !== id ||
              pending.action !== "unsnooze"
            ) {
              return;
            }

            pending.shouldCallApi = false;
            pendingUndoToastRef.current = null;

            sessionStorage.removeItem("pendingNotificationUndo");

            dispatch(
              unsnoozeNotification({
                id,
              }),
            );
          },
        },
      });

      pendingUndoToastRef.current.toastId = toastId;

      return;
    }
    dispatch(setNotiID(id));

    const response = await dispatch(
      unsnoozeNotification({
        id,
      }),
    );

    if (response?.payload?.status) {
      CommonToast({
        text: TEXT?.NOTIFICATION_UNSNOOZED_SUCCESSFULLY,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      setTestView(true);
      await dispatch(setCardAnimate(true));
      dispatch(
        updateNotificationInStore({
          response: response?.payload,
          stateToUpdate: "notificationsData",
        }),
      );
      setTimeout(() => {
        dispatch(
          updateNotificationArrayInStore({
            response: response?.payload,
            stateToUpdate: "notificationsData",
            notificationType: notificationType.toLowerCase(),
            notificationLength: selectedNotifications?.length,
          }),
        );
      }, 600);
    }
    setTimeout(() => {
      setTestView(false);

      dispatch(setCardAnimate(false));
    }, 600);
    return response;
  };

  const handleUndoNotification = async (notificationId) => {
    const pending = pendingUndoToastRef.current;

    if (!pending || pending.notificationId !== notificationId) {
      return;
    }

    pending.shouldCallApi = false;

    sessionStorage.removeItem("pendingNotificationUndo");
    pendingUndoToastRef.current = null;

    if (pending.toastId) {
      toast.dismiss(pending.toastId);
    }

    setOptimisticallyRemovedNotificationIds((prev) =>
      prev.filter((id) => id !== notificationId),
    );
    setNotificationEntryAnimationIds((prev) =>
      prev.includes(notificationId) ? prev : [...prev, notificationId],
    );

    let restoredNotification = {
      ...pending.notification,
      id: notificationId,
      new: true,
    };

    if (pending.action === "favourite" || pending.action === "unfavourite") {
      restoredNotification = {
        ...restoredNotification,
        favourite: pending.action === "unfavourite",
      };
    }

    if (pending.action === "snooze") {
      restoredNotification = {
        ...restoredNotification,
        snoozed_until: pending.notification?.snoozed_until,
      };
    }

    if (pending.action === "unsnooze") {
      restoredNotification = {
        ...restoredNotification,
        snoozed_until: pending.notification?.snoozed_until,
      };
    }

    dispatch(
      updateNotificationInStore({
        response: restoredNotification,
        stateToUpdate: "notificationsData",
      }),
    );

    dispatch(setNotiID(notificationId));
    await dispatch(setCardAnimate(true));

    setTimeout(() => {
      clearCardAnimation();
      setNotificationEntryAnimationIds((prev) =>
        prev.filter((id) => id !== notificationId),
      );
    }, 600);
  };

  const handleSnoozeConfirm = async (snoozed_until, id, isEdit) => {
    dispatch(setNotiID(id));
    const shouldShowUndo = !bulkEdit && isEdit === 0 && !isSnoozeView;

    if (shouldShowUndo) {
      await commitPendingUndo();

      const currentNotification = notificationsData?.notifications?.find(
        (notification) => notification?.id === id,
      );

      pendingUndoToastRef.current = {
        notificationId: id,
        notification: currentNotification,
        action: "snooze",
        snoozed_until,
        toastId: null,
        shouldCallApi: true,
      };

      sessionStorage.setItem(
        "pendingNotificationUndo",
        JSON.stringify({
          notificationId: id,
          action: "snooze",
          snoozed_until,
        }),
      );

      await dispatch(setCardAnimate(true));

      dispatch(
        updateNotificationInStore({
          response: {
            ...currentNotification,
            id,
            snoozed_until,
          },
          stateToUpdate: "notificationsData",
        }),
      );

      setTimeout(() => {
        const pending = pendingUndoToastRef.current;

        if (
          !pending ||
          pending.notificationId !== id ||
          pending.action !== "snooze" ||
          !pending.shouldCallApi
        ) {
          clearCardAnimation();
          return;
        }

        markNotificationAsRemoved(id);

        clearCardAnimation();
      }, 600);

      const toastId = CommonToast({
        text: TEXT?.NOTIFICATION_SNOOZED_SUCCESSFULLY,
        variant: "var(--primary-nav)",
        buttonNeeded: true,
        btnType: "btnWithoutIcon",
        btnProps: {
          btnText: TEXT?.UNDO,
          handleFunction: () => {
            handleUndoNotification(id);
          },
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-card)",
        },
        toastOptions: {
          onClose: () => {
            const pending = pendingUndoToastRef.current;

            if (!pending?.shouldCallApi) return;

            if (pending.notificationId !== id || pending.action !== "snooze") {
              return;
            }

            pending.shouldCallApi = false;
            pendingUndoToastRef.current = null;

            sessionStorage.removeItem("pendingNotificationUndo");

            dispatch(
              snoozeNotification({
                id,
                snoozed_until: pending.snoozed_until,
              }),
            );
          },
        },
      });

      pendingUndoToastRef.current.toastId = toastId;

      return;
    }

    const response = await dispatch(
      snoozeNotification({
        id,
        snoozed_until,
      }),
    );
    if (response?.payload?.status) {
      if (isEdit === 0) {
        setTestView(true);
        await dispatch(setCardAnimate(true));
      }
      if (!bulkEdit) {
        dispatch(
          updateNotificationInStore({
            response: response?.payload,
            stateToUpdate: "notificationsData",
          }),
        );
      }
      if (!bulkEdit) {
        if (isEdit === 0) {
          CommonToast({
            text: TEXT?.NOTIFICATION_SNOOZED_SUCCESSFULLY,
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
          setTimeout(() => {
            dispatch(
              updateNotificationArrayInStore({
                response: response?.payload,
                stateToUpdate: `notificationsData`,
                notificationType: notificationType.toLowerCase(),
                notificationLength: selectedNotifications?.length,
              }),
            );
          }, 600);
        }
      }
      setTimeout(() => {
        setTestView(false);

        clearCardAnimation();
      }, 600);
    }

    return response;
  };

  useEffect(() => {
    if (notiID === "") {
      dispatch(setCardAnimate(false));
    } else {
      setTimeout(() => {
        dispatch(setCardAnimate(false));
        dispatch(setNotiID(""));
      }, 2000);
    }
  }, [notiID]);

  const isNotificationChannelInactiveOrLinkageFailed =
    channelActiveStatus === false ||
    channelLinkageStatus === "failed" ||
    channelLinkageStatus === "pending";

  const visibleNotifications = notificationsData?.notifications
    ?.filter((notification) => {
      const notificationId = getNotificationId(notification);

      if (
        // When open in popup mode - drop live notification update (UI) from socket if channelLinkage or channel active has failed or not active.
        typepop === "popup" &&
        notification?.new &&
        isNotificationChannelInactiveOrLinkageFailed
      ) {
        return false;
      }

      return !optimisticallyRemovedNotificationIds.includes(notificationId);
    })
    .map((notification) => {
      const notificationId = getNotificationId(notification);
      const isLocallyRead = locallyReadNotificationIdsRef.current.has(
        String(notificationId),
      );

      if (isLocallyRead) {
        return {
          ...notification,
          read: true,
        };
      }

      if (notificationEntryAnimationIds.includes(notificationId)) {
        return {
          ...notification,
          new: true,
        };
      }

      return notification;
    });

  const isNotificationRead = (notification) =>
    notification?.read === true || notification?.read === "true";

  useEffect(() => {
    if (notificationsLoading) return undefined;

    const container = filterRef.current;

    if (!container) return undefined;

    const visibilityTimers = visibilityTimersRef.current;
    const fullyVisibleThreshold = 0.9;

    const clearVisibilityTimer = (notificationIdKey) => {
      const timer = visibilityTimers.get(notificationIdKey);

      if (timer) {
        clearTimeout(timer);
        visibilityTimers.delete(notificationIdKey);
      }
    };

    const startVisibilityTimer = (notificationId) => {
      if (!notificationId) return;

      const notificationIdKey = String(notificationId);

      if (
        markedVisibleNotificationIdsRef.current.has(notificationIdKey) ||
        visibilityTimers.has(notificationIdKey)
      ) {
        return;
      }

      const notification = notificationsData?.notifications?.find(
        (item) => String(getNotificationId(item)) === notificationIdKey,
      );

      if (!notification) return;

      if (isNotificationRead(notification)) {
        markedVisibleNotificationIdsRef.current.add(notificationIdKey);
        return;
      }

      const timer = setTimeout(() => {
        markedVisibleNotificationIdsRef.current.add(notificationIdKey);
        visibilityTimers.delete(notificationIdKey);
        queueNotificationForRead(notification);
      }, 1000);

      visibilityTimers.set(notificationIdKey, timer);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const notificationId = entry.target.dataset.notificationId;

          if (!notificationId) return;

          const notificationIdKey = String(notificationId);
          const isVisible =
            entry.isIntersecting &&
            entry.intersectionRatio >= fullyVisibleThreshold;

          if (isVisible) {
            startVisibilityTimer(notificationIdKey);
          } else {
            clearVisibilityTimer(notificationIdKey);
          }
        });
      },
      {
        root: container,
        threshold: [fullyVisibleThreshold],
      },
    );

    const notificationElements = container.querySelectorAll(
      "[data-notification-id]",
    );

    notificationElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();

      visibilityTimers.forEach((timer) => {
        clearTimeout(timer);
      });

      visibilityTimers.clear();
    };
  }, [
    notificationsLoading,
    handleMarkNotification,
    notificationsData,
    queueNotificationForRead,
  ]);

  const handleBulkSnooze = async (id, snoozed_until) => {
    setSnoozeLoading(true);
    const results = await Promise.all(
      selectedNotifications?.map((data) => {
        let result = handleSnoozeConfirm(snoozed_until, data?.id);
        return result;
      }),
    );
    if (bulkEdit) {
      fetchData();
    }
    setBulkEdit(false);
    dispatch(setBulkEditState(false));
    setselectedNotifications([]);
    setSnoozeLoading(false);
  };

  const handleBulkFav = async () => {
    if (bulkEdit) {
      fetchData();
    }
    setBulkEdit(false);
    dispatch(setBulkEditState(false));
    setselectedNotifications([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      setMoreActionPopup(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      {isChannelViewAllOpen && (
        <LargePopupRedirect
          fullviewisDisabled={false}
          fullviewdisabledBgColor={""}
          isfullViewrequired={true}
          fullviewhandleFunction={() => {
            setIsChannelViewAllOpen(false);
            navigate(`/home/notification_dashboard/channel_view_all`, {
              state: {
                notificationId: moreActionPopupID,
              },
            });
          }}
          headerTitle={TEXT?.BROADCASTED_CHANNELS}
          closeiconhandleFunction={() => {
            setMoreActionPopupID("");

            setIsChannelViewAllOpen(false);
          }}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
          headersubtext={TEXT?.BROADCASTED_CHANNELS_NOTE}
        >
          <ChannelViewAll
            notificationId={moreActionPopupID}
            popup={true}
          />
        </LargePopupRedirect>
      )}
      {showMarkAllPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={TEXT?.CONFIRM_MARK_ALL_NOTIFICATIONS_READ}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={`${TEXT?.ALL} ${notificationsData?.summary?.unread?.toLocaleString("en-IN") || "1"} ${TEXT?.NOTIFICATION?.toLowerCase() + "s"} ${TEXT?.WILL_BE_MARKED_AS_READ}`}
            btnOneText={TEXT?.CANCEL}
            btnOneHandleFunction={() => setShowMarkAllPopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={TEXT?.CONFIRM}
            btnTwoHandleFunction={async () => {
              setBulkMsg(
                `Marking ${notificationsData?.summary?.unread?.toLocaleString("en-IN") || "1"} notifications as read`,
              );
              setShowMarkAllPopup(false);
              let response;
              if (typepop === "popup" && flow === "channelDetailPage") {
                // Mark as all read by channel id
                response = await dispatch(
                  notificationsBulkEdit({
                    channel_id: channelId,
                    read: true,
                  }),
                );
              } else {
                // Mark as all read for all notification (view all page)
                response = await dispatch(
                  notificationsBulkEdit({
                    notification_ids: "all",
                    read: true,
                  }),
                );
              }
              if (response?.payload?.status && notificationType === "unread") {
                CommonToast({
                  text: TEXT?.NOTIFICATIONS_MARKED_AS_READ_SUCCESSFULLY,
                  icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
                  variant: "var(--success)",
                });
                // Switch from unread to all tab after successful mark all as read
                handleSubmit("type", "all");
                setCurrentPage(GlobalConfiguration.lengthCheckOne);
                setNotificationType("all");
                dispatch(resetNotificationsData());
              }
              setBulkMsg("");
            }}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {bulkMsg?.length > GlobalConfiguration.lengthCheckZero ? (
        <div className="fixed z-z-index-fixed-ui w-screen h-screen overflow-hidden bg-opacity-dark-opacity bg-black flex justify-center items-center">
          <div className="flex flex-col items-center gap-gap-sm">
            <Loader />
            <p className="font-semibold text-text-primary text-font-lg ">
              {bulkMsg}
            </p>
          </div>
        </div>
      ) : null}
      <div
        className={` flex relative flex-col overflow-hidden
          ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}
          ${typepop === "popup" ? "h-height-full relative" : ""}`}
      >
        <div
          className={`bg-primary-bg flex flex-col relative ${
            typepop === "popup" ? "h-height-full" : "h-screen"
          }`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop bg-opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header"></div>
          )}

          {/* ======= */}
          <div
            className={`notification_div_container flex-col ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} `}
            style={{
              transition: "all  var(--animation-fast) ease-in",
              top: typepop === "popup" ? "var(--bottom-sm)" : "var(--top-base)",
              borderTopRightRadius:
                typepop === "popup"
                  ? "var(--border-radius-md)"
                  : "var(--border-none)",
              borderTopLeftRadius:
                typepop === "popup"
                  ? "var(--border-radius-md)"
                  : "var(--border-none)",
              width: "var(--width-full)",
              zIndex:
                typepop === "popup"
                  ? "var(--z-index-tooltip)"
                  : "var(--z-index-overlay)",
            }}
          >
            <div
              className={` ${typepop === "popup" ? "" : "h-navbar-breadcrumb-height "} z-z-index-header w-full hidden Qsmd:block `}
            ></div>
            <div
              className={`noti_div_container z-z-index-header Qmd:shadow-box-shadow-bottom ${typepop === "popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
            >
              <TopNavComponent
                direction={direction}
                BottomSubText={
                  isSnoozeView
                    ? TEXT?.SNOOZED_VIEW_NOTE
                    : !bulkEdit
                      ? TEXT?.NOTIFICATIONS_BULK_EDIT_NOTE
                      : undefined
                }
                selectionIconComponentArray={[
                  {
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: notificationsLoading,
                    handleFunction: async (e) => {
                      if (isAllowed) {
                        if (!selectedNotifications?.length) return;
                        let isSelectAll = selectedNotifications?.every(
                          (not) => not.favourite,
                        );

                        setBulkMsg(
                          isSelectAll
                            ? TEXT?.REMOVING_FROM_FAVOURITES
                            : TEXT?.ADDING_TO_FAVOURITES,
                        );
                        const results = await Promise.all(
                          selectedNotifications?.map((data) => {
                            if (!data?.favourite) {
                              let result = handleMarkFavorite(
                                data?.id,
                                isSelectAll,
                                true,
                              );
                              return result;
                            } else if (isSelectAll) {
                              let result = handleMarkFavorite(
                                data?.id,
                                isSelectAll,
                                true,
                              );
                              return result;
                            }
                          }),
                        );

                        if (bulkEdit) {
                          handleBulkFav();
                        } else {
                          if (favType?.length) {
                            await dispatch(
                              updateNotificationArrayInStore({
                                response: selectedNotifications?.map(
                                  (itm) => itm?.id,
                                ),
                                stateToUpdate: `notificationsData`,
                                notificationType: "fav",
                                notificationLength:
                                  selectedNotifications?.length,
                                selectedValueLength: Number(selectedValue),
                                updatedSummary:
                                  results?.slice(-1)?.[0]?.payload,
                              }),
                            );

                            setselectedNotifications([]);
                          }
                        }

                        setTimeout(() => {
                          setBulkMsg("");
                        }, IntervalConfiguration.intervalLarge);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "Notify,Admin" },
                        });
                      }
                    },
                    isDisabled:
                      notificationsLoading ||
                      !isAllowed ||
                      !selectedNotifications?.length,
                    icon:
                      selectedNotifications?.length &&
                      selectedNotifications?.every((not) => not.favourite)
                        ? ICONS?.FAVOURITE_FILLED
                        : ICONS?.FAVOURITE,
                    title:
                      selectedNotifications?.length &&
                      selectedNotifications?.every((not) => not.favourite)
                        ? TEXT?.UNFAVOURITE
                        : TEXT?.FAVOURITE,
                    hoverOption: "white",
                  },
                  {
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: notificationsLoading,
                    handleFunction: (e) => {
                      if (isAllowed) {
                        if (
                          !notificationsLoading &&
                          isAllowed &&
                          selectedNotifications?.length
                        )
                          setShowSnoozePopup(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "Notify,Admin" },
                        });
                      }
                    },
                    isDisabled:
                      notificationsLoading ||
                      !isAllowed ||
                      !selectedNotifications?.length,
                    icon: ICONS?.SNOOZE,
                    title: TEXT?.SNOOZE,
                    imgColor: "var(--text-primary)",
                    hoverOption: "white",
                  },
                ]}
                selectionIconRoundBtnProps={{
                  enabledBgColor: "var(--primary-nav-act)",
                  isLoading: notificationsLoading,
                  handleFunction: (e) => {
                    if (!notificationsLoading) {
                      setCurrentPage(1);
                      setBulkEdit(false);
                      dispatch(setBulkEditState(false));
                      setselectedNotifications([]);
                    }
                  },
                  isDisabled: notificationsLoading,
                  icon: ICONS?.CLOSE,
                  title: TEXT?.CANCEL,
                  hoverOption: "white",
                }}
                isSelectionView={bulkEdit}
                selectionText={`Notifications selected on current page : ${selectedNotifications?.length}`}
                selectionBtnProps={{
                  btnText: `Select up to ${Number(selectedValue)}`,
                  icon:
                    (selectedNotifications?.length === Number(selectedValue) ||
                      selectedNotifications?.length ===
                        notificationsData?.notifications?.length) &&
                    selectedNotifications?.length >
                      GlobalConfiguration.lengthCheckZero
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  enabledBgColor:
                    (selectedNotifications?.length === Number(selectedValue) ||
                      selectedNotifications?.length ===
                        notificationsData?.notifications?.length) &&
                    selectedNotifications?.length >
                      GlobalConfiguration.lengthCheckZero
                      ? "var(--positive-bg)"
                      : "var(--primary-nav-act)",
                  enabledTextColor: "var(--text-primary)",
                  iconToBeAlign: "right",
                  isDisabled:
                    notificationsLoading ||
                    !notificationsData?.notifications?.length,
                  hoverOption:
                    selectedNotifications?.length === Number(selectedValue) ||
                    selectedNotifications?.length ===
                      Number(notificationsData?.notifications?.length)
                      ? "black"
                      : "white",
                  handleFunction: () => {
                    if (!notificationsLoading) handleSelectall(false);
                  },
                }}
                snoozeToggleProps={{
                  state: isSnoozeView,
                  title: isSnoozeView
                    ? `${TEXT?.UNSNOOZE}d ${TEXT?.NOTIFICATION.toLowerCase()}s`
                    : `${TEXT?.SNOOZE}d ${TEXT?.NOTIFICATION.toLowerCase()}s`,
                  isDisabled: showInnerSearchBar,
                  handleClick: (e) => {
                    e.stopPropagation();
                    if (filterRef.current) {
                      filterRef.current.scrollTop =
                        GlobalConfiguration.lengthCheckZero;
                    }
                    setBulkEdit(false);
                    dispatch(setBulkEditState(false));
                    setBulkMsg("");
                    setFavType("");
                    handleSubmit("fav", "");
                    setselectedNotifications([]);
                    setIsSnoozeView((prev) => !prev);
                    setOptimisticallyRemovedNotificationIds([]);
                  },
                }}
                BottomCtaBtnProps={
                  !bulkEdit && !isSnoozeView
                    ? {
                        btnText: TEXT?.BULK_EDIT,
                        icon: ICONS?.EDIT_WITH_WHITE_CIRCLE,
                        enabledBgColor: "var(--primary-nav-act)",
                        enabledTextColor: "var(--text-primary)",
                        iconToBeAlign: "right",
                        isDisabled:
                          notificationsLoading ||
                          notificationsBulkEditLoading ||
                          !notificationsData?.notifications?.length ||
                          !isAllowed,
                        hoverOption: "white",
                        handleFunction: () => {
                          if (isAllowed) {
                            if (
                              notificationsLoading ||
                              notificationsBulkEditLoading ||
                              !notificationsData?.notifications?.length
                            ) {
                              return;
                            } else {
                              setCurrentPage(1);
                              setBulkEdit(true);
                              dispatch(setBulkEditState(true));
                            }
                          } else {
                            navigate("/feature_not_assigned", {
                              state: { unavailableService: "Notify,Admin" },
                            });
                          }
                        },
                      }
                    : undefined
                }
                BottomCtaBtn2Props={
                  !bulkEdit && !isSnoozeView
                    ? {
                        btnText: TEXT?.MARK_ALL_AS_READ,
                        icon: ICONS?.MARK_AS_READ,
                        enabledBgColor: "var(--primary-nav-act)",
                        enabledTextColor: "var(--text-primary)",
                        iconToBeAlign: "right",
                        isDisabled:
                          notificationsLoading ||
                          notificationsBulkEditLoading ||
                          !visibleNotifications?.length ||
                          notificationsData?.summary?.unread === 0 ||
                          !isAllowed,
                        hoverOption: "white",
                        handleFunction: () => {
                          if (isAllowed) {
                            if (
                              notificationsLoading ||
                              notificationsBulkEditLoading ||
                              !notificationsData?.notifications?.length ||
                              notificationsData?.summary?.unread === 0
                            ) {
                              return;
                            } else {
                              setShowMarkAllPopup(true);
                            }
                          } else {
                            navigate("/feature_not_assigned", {
                              state: { unavailableService: "Notify,Admin" },
                            });
                          }
                        },
                      }
                    : undefined
                }
                BottomSubTextVaraint="primary"
                isToggleNeeded={true}
                filteredSearchProps={{
                  isFilterDisabled:
                    notificationsLoading ||
                    notificationsBulkEditLoading ||
                    (!notificationsData?.notifications?.length &&
                      !(
                        searchUserText?.length ||
                        targetName?.length ||
                        favType?.length ||
                        startDateFilter ||
                        endDateFilter ||
                        sortType?.length
                      )),
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  showSearchBar: false,
                  isSearchDisabled:
                    notificationsLoading ||
                    notificationsBulkEditLoading ||
                    (!notificationsData?.notifications?.length &&
                      !(
                        searchUserText?.length ||
                        targetName?.length ||
                        favType?.length ||
                        startDateFilter ||
                        endDateFilter ||
                        sortType?.length
                      )),
                  onSearchInput: (val) => setsearchUserTextDebounce(val),
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: `${TEXT?.SEARCH} ${TEXT?.NOTIFICATION.toLowerCase()}`,
                  filterPlaceholder: `${TEXT?.NOTIFICATION.toLowerCase()} / ${TEXT?.CHANNEL.toLowerCase()} ${TEXT?.NAME.toLowerCase()}`,
                  filterItems: [
                    {
                      name: TEXT?.SEARCH,
                      isMulti: false,
                      value: searchUserText,
                      setValue: (val) => {
                        setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit("search", val);
                        setSearchUserText(val);
                      },
                      isDropdown: false,
                      isDisabled: notificationsLoading,
                    },
                  ],
                  filters: [
                    {
                      name: TEXT?.DATE_RANGE,
                      filterType: "calender",
                      variant: "range",
                      size: "small",
                      value: startDateFilter && endDateFilter,
                      isDisabled: notificationsLoading,
                      startDate: startDateFilter
                        ? new Date(startDateFilter)
                        : startDateFilter,
                      endDate: endDateFilter
                        ? new Date(endDateFilter)
                        : endDateFilter,
                      handleChange: (date) => {
                        setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit("date", date);
                        handleFilterDateRange(date);
                      },
                    },
                    {
                      name: TEXT?.SHOW_HIDE_FAVOURITE,
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: [
                        TEXT?.SHOW_ONLY_FAVOURITE,
                        TEXT?.HIDE_FAVOURITE,
                      ],
                      dropdownPlaceHolder: TEXT?.SELECT_TYPE,
                      value: favType,
                      isDisabled: notificationsLoading || isSnoozeView,
                      handleChange: (val) => {
                        handleSubmit("fav", val);
                        setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        setFavType(val);
                      },
                    },
                    {
                      name: TEXT?.TARGET,
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: [
                        "Google chat",
                        "Microsoft teams",
                        "Slack",
                        "Webhook",
                      ],
                      dropdownPlaceHolder: TEXT?.SELECT_TARGET,
                      value: targetName,
                      isDisabled: notificationsLoading,
                      handleChange: (val) => {
                        handleSubmit("target", val);
                        setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        setTargetName(val);
                      },
                    },
                  ],
                  sortByFilter: [
                    {
                      name: TEXT?.DATE_NEW_TO_OLD,
                      default: true,
                      isDisabled: false,
                    },
                    {
                      name: TEXT?.DATE_OLD_TO_NEW,
                      isDisabled: false,
                    },
                  ],
                  sortValue: sortType,
                  isSortDefaultDisabled:
                    sortType === "" || notificationsLoading,
                  sortHandleChange: (val) => {
                    handleSubmit("sort", val);

                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSortType(val);
                  },
                  isSortDisabled:
                    notificationsLoading ||
                    notificationsBulkEditLoading ||
                    (!notificationsData?.notifications?.length &&
                      !(
                        searchUserText?.length ||
                        targetName?.length ||
                        favType?.length ||
                        startDateFilter ||
                        endDateFilter ||
                        sortType?.length
                      )),
                  isFilterDisabled:
                    notificationsLoading ||
                    notificationsBulkEditLoading ||
                    (!notificationsData?.notifications?.length &&
                      !(
                        searchUserText?.length ||
                        targetName?.length ||
                        favType?.length ||
                        startDateFilter ||
                        endDateFilter ||
                        sortType?.length
                      )),
                  isFilterClearAllDisabled: !(
                    notificationsLoading ||
                    targetName?.length ||
                    favType?.length ||
                    (startDateFilter && endDateFilter)
                  ),

                  isSearchClearAllDisabled: !(
                    searchUserText?.length || notificationsLoading
                  ),
                  active: active,
                  setActive: setActive,

                  notificationsLoading: notificationsLoading,
                  isShowSortBy: true,
                  isShowFilter: true,
                }}
              />
            </div>
          </div>
          {showInnerSearchBar && typepop !== "popup" && (
            <div className="absolute opacity-light-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
          )}

          <div
            ref={filterRef}
            onScroll={handleScroll}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
            }}
            className={`${
              notificationsData?.notifications?.length ===
                GlobalConfiguration.lengthCheckZero || notificationsLoading
                ? "pb-bottom-base"
                : ""
            } 
            ${isSnoozeView ? "pt-padding-md" : ""}
  ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none" : ""}
  ${
    typepop === "popup"
      ? "h-full flex flex-col gap-y-gap-md flex-1 overflow-y-auto overflow-x-hidden min-h-1"
      : "flex flex-col gap-y-gap-md h-full-height flex-1 min-h-0 overflow-y-auto"
  }`}
          >
            {isSnoozeView ? null : (
              <div className="toggle-button max-w-max-content-width w-full px-mobile-padding-l lg:px-padding-base pt-padding-md mx-auto">
                <SwitcherTabs
                  isDisabled={notificationsLoading || bulkEdit}
                  initialActiveTab={notificationType}
                  tabs={[
                    {
                      isDisabled: notificationsLoading || bulkEdit,
                      label: TEXT?.UNREAD,
                      key: TEXT?.UNREAD.toLowerCase(),
                      handler: () => {
                        if (!notificationsLoading && !bulkEdit) {
                          handleSubmit("type", "unread");
                          setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          setNotificationType("unread");
                        }
                      },
                    },
                    {
                      label: TEXT?.ALL,
                      key: TEXT?.ALL.toLowerCase(),
                      isDisabled: notificationsLoading || bulkEdit,
                      handler: () => {
                        if (!notificationsLoading && !bulkEdit) {
                          handleSubmit("type", "all");
                          setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          setNotificationType("all");
                        }
                      },
                    },
                  ]}
                />
              </div>
            )}
            {(notificationsLoading ||
              snoozeLoading ||
              (!notificationsData && !notificationsError)) &&
            !bulkMsg?.length ? (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            ) : !!visibleNotifications?.length ? (
              <div
                className={`scroll flex flex-col gap-y-gap-md items-center px-mobile-padding-l xl:px-padding-base min-h-height-base h-full z-z-index-content ${
                  showInnerSearchBar && "pointer-events-none"
                } w-full `}
              >
                {visibleNotifications?.map((data, idx) => {
                  return (
                    <NotificationViewallCard
                      handleNavigate={handleSubmit}
                      onOpenSnoozePopup={(notification) => {
                        setCardSnoozeNotification(notification);
                      }}
                      popupMode={
                        typepop === "popup" && flow === "channelDetailPage"
                      }
                      popupType={flow}
                      notiID={notiID}
                      notificationType={notificationType}
                      lastCard={visibleNotifications?.length - 1 === idx}
                      testView={testView && notiID > data.id}
                      animate={cardAnimate && notiID === data.id}
                      handleMarkFavorite={handleMarkFavorite}
                      moreActionPopup={moreActionPopup}
                      setMoreActionPopup={setMoreActionPopup}
                      moreActionPopupID={moreActionPopupID}
                      setMoreActionPopupID={setMoreActionPopupID}
                      handleMarkNotification={handleMarkNotification}
                      isChannelViewAllOpen={isChannelViewAllOpen}
                      setIsChannelViewAllOpen={setIsChannelViewAllOpen}
                      handleUnsnoozeNotification={handleUnsnoozeNotification}
                      handleSnoozeConfirm={handleSnoozeConfirm}
                      isSelected={selectedNotifications?.some(
                        (itm) => itm.id === data?.id,
                      )}
                      isSelectionView={bulkEdit}
                      key={data?.id || data?.notification_id || idx}
                      notificationData={data}
                      handleSelect={(e, id) => {
                        handleSingleSelect(
                          selectedNotifications,
                          setselectedNotifications,
                          selectedValue,
                          data,
                        );
                      }}
                    />
                  );
                })}
              </div>
            ) : !visibleNotifications?.length ||
              (typepop === "popup" &&
                isNotificationChannelInactiveOrLinkageFailed) ? (
              <div
                className={`flex flex-col items-center justify-center m-auto w-full h-full overflow-y-scroll`}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt={TEXT?.NO_DATA_FOUND}
                  className="w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p className="bene-acc-no-beneaccount-text mb-margin-sm">
                  {TEXT?.NO_DATA_FOUND}
                </p>
                {searchUserText?.length ||
                targetName?.length ||
                favType?.length ||
                startDateFilter ||
                endDateFilter ||
                sortType?.length ? (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText={TEXT?.CLEAR_PARAMETERS}
                    btnType="button"
                    handleFunction={() => {
                      clearFilter();
                      handleClearSearchParam();
                    }}
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                  />
                ) : null}
                {!(
                  searchUserText?.length ||
                  targetName?.length ||
                  favType?.length ||
                  startDateFilter ||
                  endDateFilter ||
                  sortType?.length
                ) &&
                notificationType === "unread" &&
                !isSnoozeView &&
                !visibleNotifications?.length ? (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText={`${TEXT?.VIEW_ALL} ${TEXT?.NOTIFICATION.toLowerCase()}s`}
                    btnType="button"
                    handleFunction={() => {
                      handleSubmit("type", "all");
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setNotificationType("all");
                    }}
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                  />
                ) : null}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}
          </div>
          {(visibleNotifications?.length >
            GlobalConfiguration.lengthCheckZero ||
            notificationsData?.notifications?.length >
              GlobalConfiguration.lengthCheckZero) &&
            !notificationsLoading &&
            !snoozeLoading && (
              <div
                className={`w-width-full z-z-index-content bg-primary-nav 
                ${
                  typepop === "popup"
                    ? "w-width-full Qmd:w-full_popup-width rounded-none Qmd:rounded-b-border-radius-md Qmd:rounded-t-none"
                    : "w-width-full rounded-none"
                } `}
              >
                <div
                  className={`${
                    visibleNotifications?.length ===
                    GlobalConfiguration?.lengthCheckOne
                      ? "hidden"
                      : `block ${showInnerSearchBar ? "pointer-events-none" : ""}`
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={notificationsData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    typePopup={typepop === "popup"}
                  />
                </div>
              </div>
            )}
        </div>
        {(cardSnoozeNotification || showSnoozePopup) && (
          <div className="fixed z-z-index-max flex items-center justify-center top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SnoozePopup
              headerTitle={
                TEXT?.SNOOZE + " " + TEXT?.NOTIFICATION.toLowerCase()
              }
              secondHeaderTitle={`${TEXT?.SELECT_THE_DATE_AND_TIME_TO_SNOOZE} ${
                selectedNotifications?.length >
                GlobalConfiguration.lengthCheckOne
                  ? TEXT?.THESE.toLowerCase()
                  : TEXT?.THIS.toLowerCase()
              } ${TEXT?.NOTIFICATION.toLowerCase()}.`}
              btnOneHandleFunction={() => {
                setCardSnoozeNotification(null);
                setShowSnoozePopup(false);
              }}
              notificationIdProp={cardSnoozeNotification?.id || ""}
              initialSnoozedUntil={cardSnoozeNotification?.snoozed_until}
              onConfirm={(id, snoozed_until) => {
                if (cardSnoozeNotification) {
                  handleSnoozeConfirm(
                    snoozed_until,
                    cardSnoozeNotification.id,
                    cardSnoozeNotification.snoozed_until,
                  );
                  setCardSnoozeNotification(null);
                } else {
                  handleBulkSnooze(id, snoozed_until);
                  setShowSnoozePopup(false);
                }
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationViewall;
